import { useEffect, useRef, useState, useSyncExternalStore } from "react";

import {
  readCurrentCartRuntime,
  subscribeCurrentCartRuntime,
} from "../runtime/local-store/current-cart-runtime";
import {
  applyPosUpdateAtSafePoint,
  isPosUpdateReady,
  subscribePosUpdateReady,
} from "../runtime/pwa/register";

export function PosUpdatePrompt() {
  const [ready, setReady] = useState(() => isPosUpdateReady());
  const [applying, setApplying] = useState(false);
  const autoApplyStartedRef = useRef(false);
  const currentCartRuntime = useSyncExternalStore(
    subscribeCurrentCartRuntime,
    readCurrentCartRuntime,
    readCurrentCartRuntime,
  );
  const currentCartHasLines = Boolean(currentCartRuntime.cart?.lines.length);

  useEffect(() => subscribePosUpdateReady(setReady), []);

  useEffect(() => {
    if (!ready) {
      autoApplyStartedRef.current = false;
      return;
    }
    if (currentCartHasLines || applying || autoApplyStartedRef.current) return;

    autoApplyStartedRef.current = true;
    setApplying(true);
    void applyPosUpdateAtSafePoint()
      .catch(() => {
        autoApplyStartedRef.current = false;
      })
      .finally(() => {
        setApplying(false);
      });
  }, [applying, currentCartHasLines, ready]);

  if (!ready) return null;

  return (
    <aside className="pos-update-prompt" role="status" aria-live="polite">
      <div>
        <strong>มี MORE POS เวอร์ชันใหม่</strong>
        <span>
          {currentCartHasLines
            ? "ระบบจะอัปเดตอัตโนมัติทันทีหลังจบบิลนี้ โดยไม่ล้างข้อมูล Local/Outbox"
            : "กำลังอัปเดตเวอร์ชันใหม่ที่จุดปลอดภัย…"}
        </span>
      </div>
      <button type="button" disabled>
        {currentCartHasLines ? "รอจบบิลนี้" : applying ? "กำลังอัปเดต…" : "เตรียมอัปเดต"}
      </button>
    </aside>
  );
}
